import React, { useEffect, useState } from 'react';
import withRouter from '../../components/withRouter';
import TableContainer from '../../components/TableContainerReactTable';
import { getTags } from '../../api/tagApi';
import { Tag } from '../../types/tag';
import { useProfile } from '../../hooks/UserHooks';
import TagModal from './TagModal';
import AddTagModal from './AddTagModal';

const Index = (props: any) => {
    const { userProfile } = useProfile();
    const [data, setData] = useState<Tag[]>([]);
    const [dataToEdit, setDataToEdit] = useState<Tag | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [isTagModalOpen, setIsTagModalOpen] = useState<boolean>(false);
    const [isAddTagModalOpen, setIsAddTagModalOpen] = useState<boolean>(false);

    useEffect(() => {
        // Lista os publishers cadastrados na tabela
        getTags().then((res) => {
            setData(res);

        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const handleUpdateData = (newData: Tag) => {
        const updatedData = data.map((item) => {
            if (item.id === newData.id) {
                return newData;
            }
            return item;
        });
        setData(updatedData);
    };

    const handleAddData = (newData: Tag) => {
        setData([...data, newData]);
    };

    const toggleTagModal = () => {
        setIsTagModalOpen(!isTagModalOpen);
    };

    const toggleAddTagModal = () => {
        setIsAddTagModalOpen(!isAddTagModalOpen);
    };


    const dateFormatOptions: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'shortOffset',
    };

    const columns = [
        {
            header: '#',
            cell: (cell: any) => {
                return (
                    <span className="fw-semibold">{cell.getValue()}</span>
                );
            },
            accessorKey: 'id',
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Nome',
            accessorFn: (row: any) => {
                return row.name ? row.name : '-';
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Site',
            accessorKey: 'domain',
            cell: (cell: any) => {
                const cellValue = cell.getValue();
                return cellValue ? (<>
                    {cell.getValue()} <a href={'https://' + cellValue} target="_blank" rel="noreferrer">
                        <i className="ri-external-link-line"></i></a>
                </>) : '-';
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Habilitado',
            accessorKey: 'enabled',
            cell: (cell: any) => {
                const isEnabled = cell.row.original.enabled;
                let statusStr = isEnabled ? 'Habilitado' : 'Desabilitado';
                let bgColor = isEnabled ? 'success' : 'danger';
                return <span className={`badge bg-${bgColor}`}>{statusStr}</span>;
            },
            enableColumnFilter: false,
        },
        {
            header: "Criado em",
            accessorFn: (row: any) => {
                const date = new Date(row.createdAt);
                return date.toLocaleDateString('pt-BR', dateFormatOptions);
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Atualizado em",
            accessorFn: (row: any) => {
                const date = new Date(row.updatedAt);
                return row.updatedAt ? date.toLocaleDateString('pt-BR', dateFormatOptions) : '-';
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Actions',
            cell: (cell: any) => {
                const row = cell.row.original;
                let actionCell = [];

                // Botão personificar
                if (userProfile && userProfile.role === 'ROLE_SUPER_ADMIN') {
                    // Botão de editar TAG
                    actionCell.push(<div key="action_tag">
                        <button className="btn text-primary d-inline-block"
                            id={'action_tag_' + row.id}
                            onClick={() => {
                                setDataToEdit(row);
                                toggleTagModal();
                            }}
                            title="TAG"
                        ><i className="ri-hashtag fs-16"></i></button>
                    </div>);

                    // Botão de editar
                    actionCell.push(<div key="action_edit">
                        <button className="btn text-primary d-inline-block"
                            id={'action_edit_' + row.id}
                            onClick={() => {
                                window.location.href = `/tag/${row.id}`;
                            }}
                            title="Editar"
                        ><i className="ri-pencil-fill fs-16"></i></button>
                    </div>);
                }
                return <div className="d-flex gap-2">{actionCell}</div>;
            },
            enableColumnFilter: false,
        },
    ];

    document.title = 'TAGs | Ad Pulse';
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row g-4 align-items-center">
                                        <div className="col-sm">
                                            <h5 className="card-title mb-0">TAGs</h5>
                                        </div>
                                        <div className="col-sm-auto">
                                            <button
                                                type="button"
                                                className="btn btn-info add-btn"
                                                onClick={toggleAddTagModal}
                                            >
                                                <i className="ri-add-line align-bottom me-1"></i> Nova TAG
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {!loading ? <TableContainer
                                        divClass="table-responsive"
                                        columns={(columns || [])}
                                        data={(data || [])}
                                        isGlobalFilter={true}
                                        customPageSize={30}
                                        SearchPlaceholder="Procurar..."
                                    /> :
                                        <div className="text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Carregando...</span>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {dataToEdit && (
                <TagModal
                    tag={dataToEdit}
                    isOpen={isTagModalOpen}
                    toggle={toggleTagModal}
                />
            )}

            <AddTagModal
                isOpen={isAddTagModalOpen}
                toggle={toggleAddTagModal}
            />
        </React.Fragment>
    );
};

export default withRouter(Index);